import React, { useEffect } from "react";
import { Button, Form, Flex, Row, Col, Input } from "antd";
import { useForm } from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import Select from "../components/Select";
import {
  addAnnouncement,
  updateAnnouncement,
} from "../redux/apiActions/announcementActions";
import { getAnnouncementState } from "../redux/store/getState";
import { IconPrimary, Popup } from "../components";
import { PlusOutlined } from "@ant-design/icons";
import { usePopup } from "../hooks/usePopup";
import { EditIcon } from "../assets";
import { Announcement } from "../redux/apiSlice/announcementSlice";

type Props = {
  record?: Announcement;
};

const AnnouncementForm: React.FC<Props> = ({ record }: Props) => {
  const [form] = useForm();
  const popup = usePopup();
  const { loading } = useAppSelector(getAnnouncementState);

  const dispatch = useAppDispatch();
  const onFinish = async (data: any) => {
    if (record) {
      dispatch(updateAnnouncement({ data: { id: record.id, ...data }, popup }));
    } else {
      dispatch(addAnnouncement({ data, popup }));
    }
  };

  useEffect(() => {
    if (record) {
      form.setFieldsValue(record);
    }
    return () => form.resetFields();
  }, [record, form]);

  return (
    <Popup
      ref={popup.popupRef}
      openTrigger={
        record ? (
          <IconPrimary>
            <EditIcon />
          </IconPrimary>
        ) : (
          <Button icon={<PlusOutlined />}>Add Announcement</Button>
        )
      }
    >
      <Form
        layout="vertical"
        form={form}
        initialValues={record}
        onFinish={onFinish}
      >
        <Row justify="center" style={{ marginTop: "30px" }}>
          <Col span={18}>
            <Select
              options={[
                { name: "ATC Admin", id: "atc" },
                { name: "Student", id: "user" },
              ]}
              formItemProps={{
                name: "type",
                label: "User",
                rules: [{ required: true, message: "User is required" }],
              }}
            />
            <Form.Item
              label="Title"
              name="title"
              rules={[{ required: true, message: "Title is required" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Message"
              name="message"
              rules={[{ required: true, message: "Message is required" }]}
            >
              <TextArea rows={5} />
            </Form.Item>

            <Flex justify={"center"}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  ghost
                  disabled={
                    loading.addAnnouncement || loading.updateAnnouncement
                  }
                  loading={
                    loading.addAnnouncement || loading.updateAnnouncement
                  }
                >
                  Submit
                </Button>
              </Form.Item>
            </Flex>
          </Col>
        </Row>
      </Form>
    </Popup>
  );
};

export default AnnouncementForm;
